import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "reasons" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 0,
  class: "suggestions"
}
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "view-reason" }, "驳回原因", -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "tips" }, "请重新上传相应文件/修改资料", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rejectFiles, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "reason",
          key: item.icon,
          onClick: ($event: any) => (_ctx.toUrl(item))
        }, [
          _createElementVNode("i", {
            class: _normalizeClass('iconfont ' + _ctx.getIcon(item))
          }, null, 2),
          _createElementVNode("a", null, _toDisplayString(item.fileName), 1)
        ], 8, _hoisted_3))
      }), 128))
    ]),
    (_ctx.rejectContent.length || _ctx.rejectContentOther)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _cache[0] || (_cache[0] = _createElementVNode("div", null, "修改意见", -1)),
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rejectContent, (item) => {
              return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1))
            }), 128)),
            (_ctx.rejectContentOther)
              ? (_openBlock(), _createElementBlock("li", _hoisted_5, _toDisplayString(_ctx.rejectContentOther), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_van_button, {
      class: "btn-next",
      size: "small",
      "native-type": "submit",
      type: "primary",
      onClick: _ctx.resetFormView
    }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode("重新填写资料")
      ])),
      _: 1
    }, 8, ["onClick"])
  ]))
}